import * as download from './download.js';
import * as list from './list.js';
import * as bulkRun from './bulkRun.js';
import * as bulkRetrigger from './bulkRetrigger.js';
import * as bulkKill from './bulkKill.js';
import * as bulkRollback from './bulkRollback.js';

export const jobs = [download, list, bulkRun, bulkRetrigger, bulkKill, bulkRollback];
